import React from 'react';
import { Fieldset, FormNumber } from '~/components/FormControl';
import { Form } from 'react-bootstrap';
import { formLabel } from '~/utils/helpers';

function ExtraGranted() {
    return (
        <Fieldset className={'px-2'}>
            <Fieldset.Legend>{formLabel('ExtraGranted')}</Fieldset.Legend>
            <Form.Row>
                <FormNumber
                    name="speedBuildIncrease"
                    sm={6}
                />
                <FormNumber
                    name="itemFoundIncrease"
                    sm={6}
                />
                <FormNumber
                    name="levelUpExperienceReduction"
                    sm={6}
                />
                <FormNumber
                    name="ingameShopDiscount"
                    sm={6}
                />
            </Form.Row>
        </Fieldset>
    );
}

export default ExtraGranted;
